module.exports = __webpack_public_path__ + "static/media/alarm-clock.06ffa592.svg";